/*
  =====================================================
  Lee Flora Wholesale — Wedding Page JS
  FILE: assets/lfw-wedding.js
  SCOPE: Only loaded on page.wedding template
  =====================================================
*/

(function () {
  'use strict';

  // ── FAQ Accordion ──────────────────────────────────
  document.querySelectorAll('.lfw-wd-faq__q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.parentElement;
      var section = item.closest('.lfw-wd-faq');
      if (section) {
        section.querySelectorAll('.lfw-wd-faq__item.lfw-open').forEach(function (open) {
          if (open !== item) open.classList.remove('lfw-open');
        });
      }
      item.classList.toggle('lfw-open');
    });
  });

  // ── Scroll Animate ─────────────────────────────────
  var animateEls = document.querySelectorAll('.lfw-wd-page .lfw-animate');
  if (animateEls.length > 0) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('lfw-show');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    animateEls.forEach(function (el) {
      observer.observe(el);
    });
  }
})();
